import React from 'react';
import { Box, Typography, Card, CardContent, Chip } from '@mui/material';
import { Construction } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const roleColors = { user: 'default', admin: 'error' };

export default function Placeholder({ title }) {
  const { role, user } = useAuth();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Card sx={{ textAlign: 'center', maxWidth: 420, p: 2 }}>
        <CardContent>
          <Construction sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h5" gutterBottom>{title || 'Coming Soon'}</Typography>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            This section is under development. Check back soon!
          </Typography>
          {user && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Signed in as: {user.email || user.username}
              </Typography>
              <Chip
                label={`Role: ${role?.toUpperCase()}`}
                size="small"
                color={roleColors[role] || 'default'}
                sx={{ mt: 1 }}
              />
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
